import React from 'react';
import RectPlaceholderSvg from '../../static/svg/rectPlaceholder.svg';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';

export const SmartPlayerPlaceholder = styled.div`
   margin: 1.25rem 1.25rem 0px;
   text-align: center;

   svg {
      margin: auto;
      max-width: ${cssConstants.contentWidth};
      max-height: calc(100vh - 8.5rem);
   }
`;

const VideoPlaceholder: React.FC = () => (
   <SmartPlayerPlaceholder>
      <RectPlaceholderSvg />
   </SmartPlayerPlaceholder>
);

export default VideoPlaceholder;